import React, { useState, useContext } from "react";
import { useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";

import { ModalController } from "../../../ui/homeUI/_index";
import { GROUP_DELETE, GROUP_READ_ALL } from "../../../apis/_index";
import { ONLOAD_GROUPLIST } from "../../../redux/reducers/userReducer/_index";
import axios from "axios";
import { toast } from "react-toastify";
import ServiceUtils from "../../../utils/services";

const DeleteUser = (props: any) => {
  const dispatch = useDispatch();
  const context = useContext(ModalController);

  // take props
  const taskId = props.taskId;
  const handleClose = props.handleClose;

  // funcs
  const _onClickDelete = async () => {
    const API = GROUP_DELETE + taskId.toString();

    try {
      await ServiceUtils.getV2(
        API,
        {
          headers: {
            Accept: "text/plain"
          }
        }
      )
        .then((res: any) => {
          if (res?.data?.Data[0]?.RCode === 200) {
            if (handleClose) {
              handleClose()
            }
            const takeData = async () => {
              try {
                await ServiceUtils.getV2(
                  GROUP_READ_ALL,
                  {
                    headers: {
                      Accept: "text/plain"
                    }
                  }
                )
                  .then((res: any) => {

                    if (res?.status === 200) {
                      dispatch(ONLOAD_GROUPLIST(res.data.Data));
                      handleClose();
                      context.handleClose();
                      toast.success("Xoá thành công.");
                    } else {
                      toast.error("Không kết nối được máy chủ, vui lòng kiểm tra lại đường truyền hoặc đăng nhập lại phần mềm!");
                    }
                  })
              } catch (error: any) {
                toast.error("Không kết nối được máy chủ, vui lòng kiểm tra lại đường truyền hoặc đăng nhập lại phần mềm!");
              }
            }

            takeData();
          } else {
            toast.error(res?.data?.Data[0]?.RMessage || "Không kết nối được máy chủ, vui lòng kiểm tra lại đường truyền hoặc đăng nhập lại phần mềm!");

            if (handleClose) {
              handleClose()
            }
          }
        })
    } catch (error: any) {
      toast.error(
        "Không kết nối được máy chủ, vui lòng kiểm tra lại đường truyền hoặc đăng nhập lại phần mềm!"
      );
    }
  };

  return (
    <div
      className="
      flex bg-red-400
      lg:w-[30rem] w-screen h-[10rem]
      rounded-md text-white
    "
    >
      {/* icon */}
      <div className="w-1/4 h-full  flex justify-center items-center rounded-l-md border-r-[1px] border-slate-200">
        <DeleteIcon sx={{ fontSize: 100 }} />
      </div>

      {/* content */}
      <div className="flex flex-col space-y-10 items-center justify-center w-3/4 h-full rounded-r-md">
        <p>
          Bạn có đồng ý <span className="font-semibold">XOÁ</span> nhóm quyền
          này không?
        </p>
        <div className="w-full h-max flex justify-center items-center space-x-12">
          <button
            className="w-[5rem] h-max p-2 bg-slate-500 rounded-md hover:bg-slate-400"
            onClick={_onClickDelete}
          >
            Có
          </button>
          <button
            className="w-[5rem] h-max p-2 bg-red-500 rounded-md hover:bg-red-300"
            onClick={handleClose}
          >
            Không
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUser;
